<div
    #chartContainer
    class="avoid-page-break">
    <div
        class="flex flex-row justify-center items-stretch w-full"
        [ngClass]="isHeightClassApplied() ? heightClass() : ''">
        <apx-chart
            [chart]="finalOptions().chart"
            [colors]="finalOptions().colors ?? []"
            [dataLabels]="finalOptions().dataLabels ?? {}"
            [fill]="finalOptions().fill ?? {}"
            [grid]="finalOptions().grid ?? {}"
            [labels]="finalOptions().labels ?? []"
            [legend]="finalOptions().legend ?? {}"
            [noData]="finalOptions().noData ?? {}"
            [plotOptions]="finalOptions().plotOptions ?? {}"
            [series]="finalOptions().series || []"
            [states]="finalOptions().states ?? {}"
            [stroke]="finalOptions().stroke ?? {}"
            [subtitle]="finalOptions().subtitle ?? {}"
            [title]="finalOptions().title ?? {}"
            [tooltip]="finalOptions().tooltip ?? {}"
            [xaxis]="finalOptions().xaxis ?? {}"
            [yaxis]="finalOptions().yaxis ?? {}" />
    </div>
</div>
